import { render } from "./PaymentsJournal.vue?vue&type=template&id=76602274&scoped=true"
import script from "./PaymentsJournal.vue?vue&type=script&lang=js"
export * from "./PaymentsJournal.vue?vue&type=script&lang=js"

import "./PaymentsJournal.vue?vue&type=style&index=0&id=76602274&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76602274"]])

export default __exports__